import {
    Zap, Tag, CircleDot, Droplets, Waves, Package, Shirt,
} from 'lucide-react';
import { formatDate } from '@/lib/format-es';
import type { CreateFormData } from './types';

// ─── Category Configuration ─────────────────────────────────────────────────

export const CATEGORY_CONFIG: Record<string, { label: string; icon: React.ReactNode; color: string }> = {
    señuelos: { label: 'Señuelos', icon: <Zap size={14} />, color: 'text-amber-400' },
    cañas: { label: 'Cañas', icon: <Tag size={14} />, color: 'text-emerald-400' },
    carretes: { label: 'Carretes', icon: <CircleDot size={14} />, color: 'text-blue-400' },
    hilos: { label: 'Hilos', icon: <Droplets size={14} />, color: 'text-purple-400' },
    accesorios: { label: 'Accesorios', icon: <Package size={14} />, color: 'text-cyan-400' },
    ropa: { label: 'Ropa', icon: <Shirt size={14} />, color: 'text-pink-400' },
};

// ─── Water Type Labels ──────────────────────────────────────────────────────

export const WATER_TYPE_LABELS: Record<string, { label: string; icon: React.ReactNode }> = {
    dulce: { label: 'Agua Dulce', icon: <Droplets size={12} /> },
    salada: { label: 'Agua Salada', icon: <Waves size={12} /> },
    ambas: { label: 'Ambas', icon: <Droplets size={12} /> },
};

// ─── Source Labels ───────────────────────────────────────────────────────────

export const SOURCE_LABELS: Record<string, string> = {
    aliexpress: 'AliExpress',
    decathlon: 'Decathlon',
    user: 'Usuario',
};

// ─── Rejection Templates ────────────────────────────────────────────────────

export const REJECTION_TEMPLATES = [
    { label: 'No relacionado con pesca', reason: 'El material no está relacionado con la pesca deportiva.' },
    { label: 'Enlace no funcional', reason: 'El enlace del producto no funciona o no es accesible.' },
    { label: 'Producto duplicado', reason: 'Este producto ya existe en nuestro catálogo.' },
    { label: 'Imágenes inapropiadas', reason: 'Las imágenes del producto no son apropiadas o de baja calidad.' },
    { label: 'Información insuficiente', reason: 'El material necesita más información (descripción, precio, imágenes).' },
    { label: 'Fuente no fiable', reason: 'La fuente del producto no es una tienda fiable o verificada.' },
];

// ─── Empty Create Form ──────────────────────────────────────────────────────

export const EMPTY_CREATE_FORM: CreateFormData = {
    title: '', description: '', images: [],
    price: '', originalPrice: '', currency: 'EUR',
    affiliateLink: '', source: 'aliexpress',
    category: '', waterType: '',
    externalRating: '', externalReviewsCount: '',
    recommendationReason: '',
    modalities: [],
};

// ─── Date Helpers ───────────────────────────────────────────────────────────

export const shortDate = (d: Date) => formatDate(d);

export const longDate = (d: Date) => formatDate(d);

// ─── Shared CSS Classes ─────────────────────────────────────────────────────

export const inputClass = "w-full px-3 py-2 rounded-lg border border-border bg-background text-sm text-foreground placeholder:text-muted-foreground/50 focus:outline-none focus:ring-1 focus:ring-primary/50 transition-colors";
export const labelClass = "text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-1 block";
